import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/parking/lot/list', Object.assign({}, options, { params }));

export const getParkingLotList = (params, options) =>
  request.get('/api/parking/lot/selections', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/parking/lot/detail', Object.assign({}, options, { params }));

export const beforeDelete = (params, options) =>
  request.post('/api/parking/lot/beforeDelete', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/parking/lot/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/parking/lot/save', params, options);

export const update = (params, options) => request.post('/api/parking/lot/update', params, options);
